<template>
  <!-- :class="{ 'nav-open': $sidebar.showSidebar }" -->
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
import layout from "@/views/layout/Layout.vue";
export default {
  name: "App",
  components: {
    layout,
  },
  computed: {
    layout() {
      return this.$route.meta.layout;
    },
  },
};
</script>
<style lang="scss">
// 3rd party plugins css
@import "~animate.css";

@import "~@fortawesome/fontawesome-free/css/all.css";
// @import "~bootstrap/dist/css/bootstrap.css";

@import "@/assets/sass/style.vue.scss";
@import "@/assets/sass/main.scss";

.vue-notifyjs.notifications {
  .list-move {
    transition: transform 0.3s, opacity 0.4s;
  }
  .list-item {
    display: inline-block;
    margin-right: 10px;
  }
  .list-enter-active {
    transition: transform 0.2s ease-in, opacity 0.4s ease-in;
  }
  .list-leave-active {
    transition: transform 1s ease-out, opacity 0.4s ease-out;
  }

  .list-enter {
    opacity: 0;
    transform: scale(1.1);
  }
  .list-leave-to {
    opacity: 0;
    transform: scale(1.2, 0.7);
  }
}
</style>
